/* eslint-disable no-loop-func */
import { LeftOutline } from "antd-mobile-icons";
import {
  Button,
  Form,
  InfiniteScroll,
  Input,
  List,
  NavBar,
  Picker,
  Popup,
  SpinLoading,
  Image,
  Toast,
  SearchBar,
  TextArea,
} from "antd-mobile-v5";
import { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import ImageItem from "../Wf/Form/component/ImageItem";
import instance from "../../util/axios";
import { Result } from "../../schema";
import { useEffectOnce } from "react-use";
import OutSideMap from "./component/OutSideMap";

const OutsideSignNewWrapper = styled.div`
  background: #fff;
  height: 100vh;
  textarea {
    font-size: 13px;
  }
`;
const OutsideSignNew = () => {
  const params = useParams<{
    uuid: string;
    corpId: string;
    mLong: string;
    mLati: string;
  }>();
  const [data, setData] = useState<any>({
    mode: "客户",
    objId: "",
    objName: "",
    content: "",
    attachmentIds: "",
  });
  const [modeData, setModeData] = useState<any>({
    visible: false,
    value: "",
  });
  const [popupVisible, setPopupVisible] = useState<boolean>(false);

  const [objData, setObjData] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true);
  const [searchStr, setSearchStr] = useState<any>("");
  const [pageIndex, setPageIndex] = useState<number>(1);
  const [address, setAddress] = useState<any>({
    main: "",
    detail: "",
    mLong: "",
    mLati: "",
  });
  const [addressDefault, setAddressDefault] = useState<any>({
    main: "",
    detail: "",
    mLong: "",
    mLati: "",
  });
  const getLocationOne = useCallback((mLong: any, mLati: any) => {
    if (mLong && mLong !== "116.39125") {
      instance
        .get<
          Result<{
            result: {
              formatted_address: string;
              addressComponent: any;
            };
          }>
        >(
          `/oa/common/geodecoder?lon=${mLong || "116.39125"}&lat=${
            mLati || "39.90707"
          }`
        )
        .then((resp) => {
          if (resp.data.Status === "1") {
            setAddressDefault({
              detail:
                resp.data?.Data?.result?.formatted_address || "天安门广场",
              main:
                resp.data.Data?.result?.addressComponent?.address ||
                "北京市天安门广场中央",
              mLong: mLong || "116.39125",
              mLati: mLati || "39.90707",
            });
            setAddress({
              detail:
                resp.data?.Data?.result?.formatted_address || "天安门广场",
              main:
                resp.data.Data?.result?.addressComponent?.address ||
                "北京市天安门广场中央",
              mLong: mLong || "116.39125",
              mLati: mLati || "39.90707",
            });
          }
        });
    } else {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          instance
            .get<
              Result<{
                result: {
                  formatted_address: string;
                  addressComponent: any;
                };
              }>
            >(
              `/oa/common/geodecoder?lon=${
                position.coords.longitude || "116.39125"
              }&lat=${position.coords.latitude || "39.90707"}`
            )
            .then((resp) => {
              if (resp.data.Status === "1") {
                setAddressDefault({
                  detail:
                    resp.data?.Data?.result?.formatted_address || "天安门广场",
                  main:
                    resp.data.Data?.result?.addressComponent?.address ||
                    "北京市天安门广场中央",
                  mLong: position.coords.longitude || "116.39125",
                  mLati: position.coords.latitude || "39.90707",
                });
                setAddress({
                  detail:
                    resp.data?.Data?.result?.formatted_address || "天安门广场",
                  main:
                    resp.data.Data?.result?.addressComponent?.address ||
                    "北京市天安门广场中央",
                  mLong: position.coords.longitude || "116.39125",
                  mLati: position.coords.latitude || "39.90707",
                });
              }
            });
        },
        function (positionError) {
          console.log(positionError);
        }
      );
    }
  }, []);
  const getLocationTwo = useCallback((mLong: any, mLati: any) => {
    if (mLong && mLong !== "116.39125") {
      instance
        .get<
          Result<{
            result: {
              formatted_address: string;
              addressComponent: any;
            };
          }>
        >(
          `/oa/common/geodecoder?lon=${mLong || "116.39125"}&lat=${
            mLati || "39.90707"
          }`
        )
        .then((resp) => {
          if (resp.data.Status === "1") {
            setAddress({
              detail:
                resp.data?.Data?.result?.formatted_address || "天安门广场",
              main:
                resp.data.Data?.result?.addressComponent?.address ||
                "北京市天安门广场中央",
              mLong: mLong || "116.39125",
              mLati: mLati || "39.90707",
            });
          }
        });
    } else {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          instance
            .get<
              Result<{
                result: {
                  formatted_address: string;
                  addressComponent: any;
                };
              }>
            >(
              `/oa/common/geodecoder?lon=${
                position.coords.longitude || "116.39125"
              }&lat=${position.coords.latitude || "39.90707"}`
            )
            .then((resp) => {
              if (resp.data.Status === "1") {
                setAddress({
                  detail:
                    resp.data?.Data?.result?.formatted_address || "天安门广场",
                  main:
                    resp.data.Data?.result?.addressComponent?.address ||
                    "北京市天安门广场中央",
                  mLong: position.coords.longitude || "116.39125",
                  mLati: position.coords.latitude || "39.90707",
                });
              }
            });
        },
        function (positionError) {
          console.log(positionError);
        }
      );
    }
  }, []);
  const submit = useCallback(() => {
    instance
      .post("oa/attendance/Attendance/add", {
        creatorId: params?.uuid,
        latitudePin: address?.mLati,
        longitudePin: address?.mLong,
        addressPin: address?.detail,
        picPin: data?.attachmentIds,
        remark: data?.content,
        isSignOut: true,
        mode: data?.mode,
        objId: data?.objId,
        objName: data?.objName,
      })
      .then((resp: any) => {
        if (resp.data.Status === "1") {
          Toast.show({
            content: "签到成功！",
          });
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          window.postMessage("/closeWebView");
        }
      });
  }, [
    address?.detail,
    address?.mLati,
    address?.mLong,
    data?.attachmentIds,
    data?.content,
    data?.mode,
    data?.objId,
    data?.objName,
    params?.uuid,
  ]);

  const InfiniteScrollContent = ({ hasMore }: { hasMore?: boolean }) => {
    return (
      <>
        {hasMore ? (
          <>
            <SpinLoading />
          </>
        ) : (
          <span>没有更多了</span>
        )}
      </>
    );
  };

  const loadData = useCallback(
    async (tableName?: any, isNew?: boolean, str?: any) => {
      const tableNameNew = tableName ? tableName : data?.mode;
      const resp = await instance.post(
        "crm/intelligentTableView/getGridDataByTableName",
        {
          tableName:
            tableNameNew === "客户"
              ? "可看客户"
              : tableNameNew === "商机"
              ? "crm_sale_chance"
              : "crm_project",
          fuzzySearch: str === "none" ? "" : str || searchStr,
          searchField_string_name: "",
          pageIndex: isNew ? 1 : pageIndex,
          pageSize: 10,
        }
      );
      if (resp.data.Status === "1") {
        setPageIndex((prevState) => (isNew ? 1 : prevState + 1));

        if (resp.data.Data.data.length < 10) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
        let newlist = resp.data.Data.data.map((item: any) => ({
          id: item.uuid,
          avatar: "/mode.png",
          name: item?.name,
          description: item?.address,
        }));
        const arr2 =
          isNew || pageIndex === 1 ? [] : JSON.parse(JSON.stringify(objData));
        setObjData(arr2.concat(newlist));
      } else {
        setHasMore(false);
      }
    },
    [data?.mode, objData, pageIndex, searchStr]
  );
  useEffectOnce(() => {
    getLocationOne(params?.mLong, params?.mLati);
  });

  return (
    <OutsideSignNewWrapper>
      <NavBar
        style={{ height: 53 }}
        backArrow={<LeftOutline />}
        onBack={() => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          window.postMessage("/closeWebView");
        }}
      >
        外勤打卡
      </NavBar>
      <OutSideMap
        data={address}
        dataDefault={addressDefault}
        key={address?.mLong}
        onChangeData={(mlong: any, mlati: any) => {
          getLocationTwo(mlong, mlati);
        }}
        onChangeLoading={(status: any) => {
          setLoading(status);
        }}
      />
      <div style={{ width: "100%" }}>
        <div style={{ background: "#f1f2f6", height: 8, width: "100%" }}></div>
        <Form
          layout="horizontal"
          footer={
            <Button
              block
              color="primary"
              size="large"
              disabled={loading}
              onClick={() => {
                submit();
              }}
            >
              {new Date()
                .toLocaleTimeString("chinese", { hour12: false })
                .substring(0, 5)}
              外勤打卡
            </Button>
          }
        >
          <Form.Item
            name="mode"
            label="拜访类别"
            childElementPosition="right"
            arrow={null}
          >
            <div style={{ display: "flex" }}>
              <div
                style={{
                  padding: "2px 17px",
                  borderRadius: 16,
                  textAlign: "center",
                  marginRight: 8,
                  fontSize: 13,
                  background: data?.mode === "客户" ? "#D7E7FF" : "#f7f7f7",
                  border: data?.mode === "客户" ? "1px solid #65A3FF" : "none",
                }}
                onClick={() => {
                  setData((pre: any) => ({
                    ...pre,
                    mode: "客户",
                    objName: "",
                    objId: "",
                  }));
                  loadData("客户", true);
                }}
              >
                客户
              </div>
              <div
                style={{
                  padding: "2px 17px",
                  borderRadius: 16,
                  textAlign: "center",
                  marginRight: 8,
                  fontSize: 13,
                  background: data?.mode === "商机" ? "#D7E7FF" : "#f7f7f7",
                  border: data?.mode === "商机" ? "1px solid #65A3FF" : "none",
                }}
                onClick={() => {
                  setData((pre: any) => ({
                    ...pre,
                    mode: "商机",
                    objName: "",
                    objId: "",
                  }));
                  loadData("商机", true);
                }}
              >
                商机
              </div>
              <div
                style={{
                  padding: "2px 17px",
                  borderRadius: 16,
                  textAlign: "center",
                  fontSize: 13,
                  background: data?.mode === "项目" ? "#D7E7FF" : "#f7f7f7",
                  border: data?.mode === "项目" ? "1px solid #65A3FF" : "none",
                }}
                onClick={() => {
                  setData((pre: any) => ({
                    ...pre,
                    mode: "项目",
                    objName: "",
                    objId: "",
                  }));
                  loadData("项目", true);
                }}
              >
                项目
              </div>
            </div>
          </Form.Item>
          <Form.Item
            name="obj"
            label="拜访对象"
            childElementPosition="right"
            onClick={() => {
              if (!data?.mode) {
                Toast.show({
                  content: "请先选择拜访类别！",
                });
                return;
              }
              setPopupVisible(true);
            }}
          >
            <div>{data?.objName}</div>
          </Form.Item>
          <TextArea
            placeholder="请输入内容"
            style={{
              fontSize: 13,
              border: "1px solid #D8D8D8",
              padding: "4px",
              margin: "1px 13px",
              width: "90%",
            }}
            value={data?.content}
            rows={4}
            onChange={(value) => {
              setData((pre: any) => ({ ...pre, content: value }));
            }}
          />
          <div style={{ marginLeft: 5 }}>
            <ImageItem
              value={data.attachmentIds?.split(",")}
              placeholder={"照片"}
              width={"310px"}
              onChange={(data: any) => {
                setData((pre: any) => ({ ...pre, attachmentIds: data }));
              }}
            />
          </div>
        </Form>
      </div>
      <Popup
        visible={popupVisible}
        onMaskClick={() => {
          setPopupVisible(false);
        }}
        onClose={() => {
          setPopupVisible(false);
        }}
        bodyStyle={{ height: "66vh", overflow: "auto" }}
      >
        <div>
          <div style={{ padding: "7px 6px", background: "#fff" }}>
            <SearchBar
              placeholder="请输入内容"
              value={searchStr}
              onChange={(value) => {
                setSearchStr(value);
                loadData("", true, value ? value : "none");
              }}
            />
          </div>
          <List>
            {objData.map((item, index) => (
              <List.Item
                onClick={() => {
                  setPopupVisible(false);
                  setData((pre: any) => ({
                    ...pre,
                    objName: item?.name,
                    objId: item?.uuid,
                  }));
                }}
                key={index}
                prefix={
                  <div
                    style={{
                      padding: 12,
                      borderRadius: 40,
                      background:
                        index % 4 === 0
                          ? "#4BC68F"
                          : index % 4 === 1
                          ? "#8F55F4"
                          : index % 4 === 2
                          ? "#2367FB"
                          : "#F38608",
                    }}
                  >
                    <Image
                      src={item.avatar}
                      style={{ borderRadius: 20 }}
                      fit="cover"
                      width={22}
                      height={22}
                    />
                  </div>
                }
                description={item.description || "无"}
              >
                {item.name}
              </List.Item>
            ))}
          </List>
          <InfiniteScroll loadMore={loadData} hasMore={hasMore}>
            <InfiniteScrollContent hasMore={hasMore} />
          </InfiniteScroll>
        </div>
      </Popup>
    </OutsideSignNewWrapper>
  );
};
export default OutsideSignNew;
